<template>
  <div>
    <el-card shadow="never" class="mb-10px">
      <div
        style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;"
      >
        <div style="display: flex;align-items: center;flex-direction: row;">
          <div class="icon-bg">
            <div class="icon-target"></div>
          </div>
          <div style="flex-grow: 1;padding-left: 16px;">
            <div class="mb-1" style="color: #101010;font-size: 18px;">
              {{ displayName }}
            </div>
            <div
              v-if="info.inspectionNo"
              style="display: flex;align-items: center;color: #6C6C6C;font-size: 14px;"
            >
              <span>NO： </span>
              <span>{{ info.inspectionNo }}</span>
              <el-divider direction="vertical" />

              <div class="status-tag">
                <el-tag size="mini" :type="info.status">
                  {{ info.v_status }}
                </el-tag>
              </div>

              <el-divider direction="vertical" />
              <span class="mr-2">{{ '最新更新' }}:</span>
              <span>{{
                `${info.modifyByName || '--'} at ${info.modifyTime || '--'}`
              }}</span>
            </div>
          </div>
        </div>
        <div class="mt-4 ml-75px d-flex">
          <div v-if="allow('M') && isEditPage">
            <el-button size="small" plain @click="optCommand('edit')">
              {{ $l('menu_label_edit') || '编辑' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('D') && isDelPage">
            <el-button size="small" plain @click="optCommand('delete')">
              {{ $l('menu_label_delete') || '删除' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('M') && isSavePage">
            <el-button size="small" plain @click="optCommand('save')">
              {{ $l('menu_label_save') || '保存' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="isSubmitInspection && allow('T')">
            <el-button
              size="small"
              plain
              @click="optCommand('submitInspection')"
            >
              {{ $l('menu_label_submitInspection') || '提交质检' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('C') && isAudit">
            <el-button size="small" plain @click="optCommand('audit')">
              {{ $l('menu_label_approved') || '审核通过' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('R') && isAudit">
            <el-button size="small" plain @click="optCommand('reject')">
              {{ $l('btn_reject') || '驳回' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('S') && isSubPage">
            <el-button size="small" plain @click="optCommand('saveSubmit')">
              {{ $l('menu_label_saveSubmit') || '保存并提交' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('P') && isStopPage">
            <el-button size="small" type="danger" plain @click="optCommand('stop')">
              {{ $l('menu_label_stop') || '停止检验' }}
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="mt-2">
      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :inspectionCode="params.code"
        @loadData="loadData"
        @major-change="onMajorChange"
        @updatePageCode="pageTypeCode = 'detail'"
        @close="closeCurPage"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'

export default {
  mixins: [EditLoading],
  name: 'quality-fabricInspectionReport-detail',
  components: {
    EditForm,
  },
  data() {
    return { info: {}, pageTypeCode: 'detail', hasMajorNonconformity: false }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail' && this.pageTypeCode != 'edit'
    },
    displayName() {
      const { fabricNo, fabricName, inspectionDate, scmName } = this.info
      if (!fabricNo && !fabricName) {
        return this.$l('header_label_title') || '面料检验报告'
      }
      return [
        fabricNo,
        fabricName,
        inspectionDate,
        this.$l('header_label_text') || '面料检验',
        scmName,
      ]
        .filter(Boolean)
        .join(' ')
    },
    isEditPage() {
      return (
        this.pageType === 'detail' &&
        this.pageTypeCode === 'detail' &&
        this.info.inspectionCode &&
        ['N', 'Q'].includes(this.info.status)
      )
    },
    isSavePage() {
      return this.pageTypeCode === 'edit' || this.pageType === 'add'
    },
    isSubmitInspection() {
      return this.info.inspectionCode && this.info.status === 'N'
    },
    isDelPage() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        ['N', 'Q'].includes(this.info.status)
      )
    },
    isSubPage() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        this.info.status === 'Q'
      )
    },
    isStopPage() {
      return this.isSubPage && this.hasMajorNonconformity
    },
    isAudit() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        ['R', 'T'].includes(this.info.status)
      )
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),

    loadData(data) {
      this.info = { ...data }
    },
    onMajorChange(val) {
      this.hasMajorNonconformity = !!val
    },
    optCommand(menuType) {
      const { inspectionCode } = this.info
      switch (menuType) {
        case 'edit':
          this.pageTypeCode = 'edit'
          break
        case 'delete':
          this.$refs.editForm.del({ inspectionCode })
          break
        case 'audit':
          this.$refs.editForm.audit({ inspectionCode })
          break
        case 'reject':
          this.$refs.editForm.reject({ inspectionCode })
          break
        case 'save':
          this.$refs.editForm.save()
          break
        case 'submitInspection':
          this.$refs.editForm.submitInspection({ inspectionCode })
          break
        case 'saveSubmit':
          this.$refs.editForm.saveSubmit({ inspectionCode })
          break
        case 'stop':
          this.$refs.editForm.openStopReview({ inspectionCode })
          break
      }
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.el-card) {
  border: none;
  .el-card__body {
    position: relative;
    padding: 10px 15px;
  }
}

:deep(.el-card.content-card) {
  > .el-card__body {
    height: calc(100% - 20px);
  }
}

.tabs-pane {
  flex-grow: 1;
  padding-top: 16px;
}

.icon-bg {
  --size: 60px;
  width: var(--size);
  height: var(--size);
  background-image: url(./icon/hexagon.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .icon-target {
    width: 100%;
    height: 100%;
    background-image: url(./icon/file-list.png);
    background-size: 30px 30px;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}

::v-deep .status-tag {
  font-size: 12px;
  .el-tag--N {
    color: #101010;
    background-color: #f4f4f5;
    border: 1px solid #91939a;
  }
  .el-tag--Q {
    color: #e6a23c;
    background-color: #ffffff;
    border: 1px solid #f5dab1;
  }
  .el-tag--S {
    color: #70ce46;
    background-color: #e3f7d0;
    border: 1px solid #b7eb8f;
  }

  .el-tag--R {
    color: #007bff;
    background-color: #e9f3ff;
  }
  .el-tag--T {
    color: #f74852;
    background-color: #ffffff;
    border: 1px solid #f74852;
  }
  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: 1px solid #ffa39e;
  }
}
</style>
